import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";

function normalizeLocationPermission(status) {
  if (status.location === "granted" || status.coarseLocation === "granted") {
    return "granted";
  }
  if (["prompt", "prompt-with-rationale"].includes(status.location) ||
      ["prompt", "prompt-with-rationale"].includes(status.coarseLocation)) {
    return "prompt";
  }
  return "denied";
}

export async function readNativeLocationPermission() {
  if (!Capacitor.isNativePlatform()) return "unavailable";
  try {
    return normalizeLocationPermission(await Geolocation.checkPermissions());
  } catch (error) {
    // Android may throw when Location services are switched off.
    console.warn("Unable to check driver location permission.", error);
    return "unavailable";
  }
}

export async function requestNativeLocationPermission() {
  const current = await readNativeLocationPermission();
  if (current !== "prompt") return current;
  try {
    return normalizeLocationPermission(
      await Geolocation.requestPermissions({ permissions: ["location", "coarseLocation"] })
    );
  } catch (error) {
    console.warn("Unable to request driver location permission.", error);
    return "unavailable";
  }
}
